import React, { useState } from 'react'
import { TagMarker } from './tag'

import { AiTools } from '.'
import { useHistory } from 'react-router-dom'
interface Props {
  resource: AiTools
}

const AitoolsCard: React.FC<Props> = ({ resource }) => {
  const history = useHistory()
  const toToolInfo = () => {
    console.log(resource)
    history.push({
      pathname: '/aitools/' + resource.id,
      state: {
        resource: resource
      },
    })
  }
  return (
    <>
      <div onClick={toToolInfo} className="resource-card">
        <div
          className="resource-card-image"
          style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/${resource.logo})`, backgroundRepeat: "no-repeat", backgroundPosition: "center" }}
        >

        </div>
        <div className="resource-info-group">
          <div className="bold" style={{ height: 30, overflow: 'hidden', color: '#40A9FF' }}>
            {resource.name}
          </div>
          <div className="resource-author-group">
            <TagMarker suffix={resource.type} />
          </div>
        </div>
      </div>
    </>
  )
}

export default AitoolsCard
